import { render, staticRenderFns } from "./WorkOrderDetails.vue?vue&type=template&id=0ffb87fd&scoped=true&"
import script from "./WorkOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./WorkOrderDetails.vue?vue&type=style&index=0&id=0ffb87fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb87fd",
  null
  
)

component.options.__file = "WorkOrderDetails.vue"
export default component.exports